import Vue from 'vue'
import Router from 'vue-router'
// import Layout from '@/views/layout'
// import LayoutConfig from '@/views/layoutConfig'
Vue.use(Router)
export const constantRouterMap = [
  {
    path: '*',
    redirect: '/'
  },
  {
  	  path: '/',
  	  component: () => import('@/views/layout')
  },
  {
	  path: '/layoutConfig',
	  component: () => import('@/views/layoutConfig')
  }
 ]
export default new Router({
  mode: 'hash', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
